import React , {useEffect, useState} from "react";
import { useNavigate , useLocation } from "react-router";
import { ArrowLeft, ArrowRight } from "lucide-react";

import QuestionnaireManager from "../../../businessLayer/managers/QuestionnaireManager";
import HttpStatusCode from "../../../utils/httpProtocol/HttpStatusCode";
import LocalStorageDataStorer from "../../../dataAccessLayer/localStorage/LocalStorageDataStorer";
import LocalStorageKey from "../../../dataAccessLayer/localStorage/LocalStorageKey";
import QuestionnaireCreator from "../../../businessLayer/objectCreator/QuestionnaireCreator";
import NotificationMessage from "../../../utils/stringLiterals/NotificationMessage";
import AccessControlInspector from "../../../serviceLayer/authorization/AccessControlInspector";



export default function Questionnaire(props){
    
    const navigate = useNavigate();
    const location = useLocation();
        
    const _emptyMessage = "";
    const _initialPage = 1;
    const _initialTotalPages = 0;
    const _limitPerPage = 5;
    const [_currentPage, setCurrentPage] = useState(_initialPage);
    const [_totalPages, setTotalPages] = useState(_initialTotalPages);
    const [_randomizedQuestionnaire, setRandomizedQuestionnaire] = useState([]);
    const [generalMessage, setGeneralMessage] = useState("");
    const [warningStates, setWarningStates] = useState();
    const [canDisplayPage, setCanDisplayPage] = useState(false);

    useEffect(()=>{
        //console.log("Questionnaire-useEffect-_currentPage" , _currentPage);
        //console.log("Questionnaire-useEffect-_initialPage" , _initialPage);
        processUserPermissions(props.resource.name, props.resource.actions);
        if(_currentPage === _initialPage){
            const activeQuestionnaire = LocalStorageDataStorer.getItemFromLocalStorage(LocalStorageKey.QuestionnaireUserResponses);
            //console.log("Questionnaire-useEffect-activeQuestionnaire" , activeQuestionnaire);
            if(activeQuestionnaire){
                const onDisplay = true;
                const pageInfo = QuestionnaireCreator.CreatePageInfo(_currentPage,_limitPerPage,onDisplay);
                const questionsForDisplay = QuestionnaireManager.processDisplayOnQuestionnairePageForward(pageInfo , activeQuestionnaire);
                setRandomizedQuestionnaire(questionsForDisplay);
                processsetWarningStates(activeQuestionnaire.length);
                const totalPages = LocalStorageDataStorer.getItemFromLocalStorage(LocalStorageKey.totalQuestionnairePages);
                setTotalPages(totalPages);
                return;
            }
            QuestionnaireManager.getQuestionnaire(getQuestionnaireCallback)
        }       
    },[]);
        //console.log("useEffect-WARNINGSTATES", warningStates); 
    useEffect(()=>{}, [warningStates]);

    function processUserPermissions(resourceName , actions){
        //console.log("questionnaire-processUserPermissions-resourceName" , resourceName);
        //console.log("questionnaire-processUserPermissions-actions" , actions);
        const userCanDisplayPage = AccessControlInspector.userHasPermission(resourceName, actions._display_page);
        setCanDisplayPage(userCanDisplayPage);
    }

    function goBackward(){ 
        const currentPage = LocalStorageDataStorer.getItemFromLocalStorage(LocalStorageKey.currentQuestionnairePage);
        const totalErrorMessages = getAllErrorMessagesCount(currentPage,_limitPerPage, _randomizedQuestionnaire);
        processGeneralMessage(totalErrorMessages);
        if(totalErrorMessages > 0) return;
        const priorPage = currentPage - 1;
        if(priorPage < _initialPage) return;
        
        const currentPageOnDisplay = false;
        const currentPageInfo = QuestionnaireCreator.CreatePageInfo(currentPage, _limitPerPage, currentPageOnDisplay);
        const questionsForDisplay = QuestionnaireManager.processDisplayOnQuestionnairePageReverse(currentPageInfo, _randomizedQuestionnaire);
        
        const priorPageOnDisplay = true;        
        const priorPageInfo = QuestionnaireCreator.CreatePageInfo(priorPage, _limitPerPage,priorPageOnDisplay);
        const priorQuestionsForDisplay = QuestionnaireManager.processDisplayOnQuestionnairePageReverse(priorPageInfo, questionsForDisplay);
        
        LocalStorageDataStorer.setItemInLocalStorage(LocalStorageKey.currentQuestionnairePage, priorPage);
        setCurrentPage(priorPage);
        setRandomizedQuestionnaire(priorQuestionsForDisplay);
        LocalStorageDataStorer.setItemInLocalStorage(LocalStorageKey.QuestionnaireUserResponses,priorQuestionsForDisplay );
    }

    function goForward(){        
        const totalPages = LocalStorageDataStorer.getItemFromLocalStorage(LocalStorageKey.totalQuestionnairePages);
        const currentPage = LocalStorageDataStorer.getItemFromLocalStorage(LocalStorageKey.currentQuestionnairePage);
        
        const totalErrorMessages = getAllErrorMessagesCount(currentPage,_limitPerPage, _randomizedQuestionnaire);
        //console.log('goForward-totalErrorMessages', totalErrorMessages);
        processGeneralMessage(totalErrorMessages);
        if(totalErrorMessages > 0) return;
        const nextPage = currentPage + 1;
        if(nextPage > totalPages) return;
        
        const currentPageOnDisplay = false;
        const currentPageInfo = QuestionnaireCreator.CreatePageInfo(currentPage, _limitPerPage, currentPageOnDisplay);
       
        const questionsForDisplay = QuestionnaireManager.processDisplayOnQuestionnairePageForward (currentPageInfo, _randomizedQuestionnaire);
        const nextPageOnDisplay = true;        
        const nextPageInfo = QuestionnaireCreator.CreatePageInfo(nextPage, _limitPerPage, nextPageOnDisplay); 
        const nextQuestionsForDisplay = QuestionnaireManager.processDisplayOnQuestionnairePageForward(nextPageInfo, questionsForDisplay);

        LocalStorageDataStorer.setItemInLocalStorage(LocalStorageKey.currentQuestionnairePage, nextPage);
        setCurrentPage(nextPage);
        setRandomizedQuestionnaire(nextQuestionsForDisplay);
        LocalStorageDataStorer.setItemInLocalStorage(LocalStorageKey.QuestionnaireUserResponses, nextQuestionsForDisplay );
    }

    
    function goBackToMainPage(){
        navigate("/private/main" , { state: { fromPage: location.pathname } });
    }

    function onCheckboxChangeEvent(questionID ,choiceID ){        
        //const currentPage = LocalStorageDataStorer.getItemFromLocalStorage(LocalStorageKey.currentQuestionnairePage);        
        //console.log("onCheckboxChangeEvent-questionID", questionID);
        //console.log("onCheckboxChangeEvent-choiceID", choiceID);
        processSingleErrorMessage(questionID);
        const updatedQuestionnaire = QuestionnaireManager.getUpdatedQuestionnaireOnCheckboxChange(questionID, choiceID, _randomizedQuestionnaire);
        setRandomizedQuestionnaire(updatedQuestionnaire);
        setGeneralMessage(_emptyMessage);
    }

    function submitQuestionnaireResponses(event){
        //console.log("submitQuestionnaireResponses", event);

        const currentPage = LocalStorageDataStorer.getItemFromLocalStorage(LocalStorageKey.currentQuestionnairePage);
        
        const totalErrorMessages = getAllErrorMessagesCount(currentPage,_limitPerPage, _randomizedQuestionnaire);
        //console.log('goForward-totalErrorMessages', totalErrorMessages);
        processGeneralMessage(totalErrorMessages);
        if(totalErrorMessages > 0) return;

        const totalAnswers = getTotalQuestionsAnswered(_randomizedQuestionnaire);
        if(totalAnswers !== _randomizedQuestionnaire.length){
            setGeneralMessage(NotificationMessage.ReviewAnswers);

            return;
        }

        LocalStorageDataStorer.setItemInLocalStorage(LocalStorageKey.QuestionnaireUserResponses,_randomizedQuestionnaire);

        navigate("/private/questionnaire/submission" , { state: { fromPage: location.pathname } });
    }
    //#region Private Functions BEGIN
    function getQuestionnaireCallback(httpResponse){
        if(httpResponse.code === HttpStatusCode._200ok.code){
            LocalStorageDataStorer.setItemInLocalStorage(LocalStorageKey.currentQuestionnairePage, _currentPage);
            const randomizedQuestionnaireArray = LocalStorageDataStorer.getItemFromLocalStorage(LocalStorageKey.QuestionnaireUserResponses);
            processsetWarningStates(randomizedQuestionnaireArray.length);
            
            const totalPages = Math.ceil(randomizedQuestionnaireArray.length / _limitPerPage);
            LocalStorageDataStorer.setItemInLocalStorage(LocalStorageKey.totalQuestionnairePages, totalPages);
            setTotalPages(totalPages);

            const onDisplay = true;
            const pageInfo = QuestionnaireCreator.CreatePageInfo(_currentPage,_limitPerPage,onDisplay);
            const questionsForDisplay = QuestionnaireManager.processDisplayOnQuestionnairePageForward(pageInfo , randomizedQuestionnaireArray);
            setRandomizedQuestionnaire(questionsForDisplay);
        }
    }

    function processsetWarningStates(totalItems){
        setWarningStates(
            // Initialize an array of objects for each state
            Array.from({ length: totalItems }, (_, index) => ({
                id: index + 1,
                message: '', // The actual state value
            }))
        );
    }
    function getAllErrorMessagesCount(pageNumber, limit, allQuestions){
        //console.log("getAllErrorMessagesCount-pageNumber", pageNumber);
        //console.log("getAllErrorMessagesCount-limit", limit);
        //console.log("getAllErrorMessagesCount-allQuestions", allQuestions);

        let countErrorMessages = 0;
        const selectedPageIndex = (pageNumber - 1) * limit;
        const topLimit = selectedPageIndex + limit;
        const topLimitIndex = (topLimit > _randomizedQuestionnaire.length) ? _randomizedQuestionnaire.length: topLimit;

        for(let i = selectedPageIndex; i< topLimitIndex; i++){
            let countFalse = 0;
            for(let j =0; j < _randomizedQuestionnaire[i].choices.length; j++){
                const isChecked = _randomizedQuestionnaire[i].choices[j].checked;
                if(!isChecked){
                    countFalse++;
                }                
            }
            if(countFalse === _randomizedQuestionnaire[i].choices.length){
                let id = i+1;
                updateMessage(id, NotificationMessage.YouMustSelectAChoice);
                countErrorMessages++;
            }else{
                let id = i+1;
                updateMessage(id,_emptyMessage );
            }
        }

        return countErrorMessages;
    }

    function processSingleErrorMessage(questionID){        
        const foundQuestionIndex = _randomizedQuestionnaire.findIndex((question)=>{
            return (question.QuestionID === questionID );
        });
        //console.log("processSingleErrorMessage-foundQuestionIndex", foundQuestionIndex);
        if(foundQuestionIndex !== -1){
            const id = foundQuestionIndex + 1;
            updateMessage(id, _emptyMessage);
        }
    }
    
    const updateMessage = (id, newMessage) => {
        setWarningStates(prevStates =>
            prevStates.map(state =>
                state.id === id ? { ...state, message: newMessage } : state
            )
        );
    };

    function processGeneralMessage(totalErrorMessages){
        if(totalErrorMessages > 0){
            setGeneralMessage(NotificationMessage.MustAnswerAllQuestions);
        }else{            
            setGeneralMessage(_emptyMessage);
        }
    }

    function getTotalQuestionsAnswered(allQuestions){
        let counter = 0;
        for(let i = 0; i< allQuestions.length; i++){
            allQuestions[i].choices.forEach((choice)=>{
                if(choice.checked){
                    counter++;
                }
            });
        }
        return counter;
    }
    //#region Private Functions END

    
    return (<div className="app-container container-flex-column">          
                <div className="questionnaire-header-grid">
                    {_currentPage === _initialPage ?
                        <button  className="arrow-left btn-element btn-h25 btn-w65 font-s12 position-rel t-10" onClick={goBackToMainPage}>Cancel</button>
                        :                    
                        <ArrowLeft color="#0C162F" size={48} strokeWidth={3} className="arrow-left" onClick={goBackward}/>
                    }
                    <h1 className="title font-s15"> Page {_currentPage} of {_totalPages} Pages</h1>

                    {_currentPage === _totalPages ?
                      <button  className="arrow-right btn-element btn-h25 btn-w65 font-s12 position-rel t-10" onClick={submitQuestionnaireResponses}>Submit</button>
                        :
                      <ArrowRight color="#0C162F" size={48} strokeWidth={3} className="arrow-right" onClick={goForward}/>
                    }
                </div>
                { canDisplayPage && <>
                    <span className="general-message">{generalMessage}</span>
                    <ul className="questionnaire-list position-rel t-20">
                        {_randomizedQuestionnaire.map((question, index)=>(

                        question.display ? 
                        (
                            <li key={question.QuestionIndex} className="flex-column-items-start question-card">
                                <div className="flex-column w-100perc">               
                                    <span key={question.QuestionID} id={question.QuestionID} className="warning-message">{warningStates[index]?.message ?? ""} </span>
                                </div>
                                <span className="font-s15"> <strong>{question.Title}</strong> </span> 
                                <span className="font-s15"> {question.Text}</span>
                                <ul key={question.orderNumber} className="choices-container">
                                    {
                                        question.choices.map((choice)=>(
                                            <li key={choice.ChoiceID} className="choice-item">
                                                <input type="checkbox" 
                                                    id={choice.ChoiceID}
                                                    name={choice.choiceOrder}
                                                    className="choice-checkbox position-rel left-10"                 
                                                    checked={choice.checked}
                                                    onChange={()=>{onCheckboxChangeEvent(question.QuestionID ,choice.ChoiceID )}}
                                                />
                                                <span className="choice-text font-s12 position-rel left-10 mr-10 t-wrap">
                                                    {choice.Text}
                                                </span>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </li>
                        )             
                        :
                        ("")  
                        ))}
                    </ul>  
                </> }  
            </div>)
}